module.exports = __webpack_public_path__ + "img/bg.c38a723d.png";